import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useLoggedInUser from 'src/hooks/user/useLoggedInUser';

export default function RedirectToJoinClassPage() {
  const loggedInUser = useLoggedInUser();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/student') return;
    if (!loggedInUser) return;
    if (loggedInUser.isLoading) return;

    const hasClass = !!loggedInUser.data?.studentReferences?.classId;

    if (!hasClass) navigate('/student');
  }, [loggedInUser.data, loggedInUser.isLoading]);

  return null;
}
